import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { NonLogin } from '../../shared/Notification/NonLogin'
import { Empty } from '../../shared/Notification/Empty'
import AhoyEvent from "shared/ahoy_event";
import NotificationDataModel from '../../shared/Notification/DataModel';
import TimeagoAdapter from "../../../commons/TimeagoAdapter/TimeagoAdapter"

function NotificationPreviewItem({ notification }) {
  const referrerURL = () => {
    const url = new URL(notification.url)
    url.searchParams.set('referrer_feature', 'notification')

    return url.href
  }

  const sendEvent = (e) => { 
    // added to avoid error since JSDOM does not support navigation
    // https://github.com/jsdom/jsdom/issues/2112
    if(process.env.NODE_ENV === 'test') {
      e.preventDefault()
    }

    AhoyEvent.send("VIDIO::NOTIFICATION", {
      action: 'click',
      section: "all",
      notif_title: notification.title,
      notif_message: notification.body,
      url_deeplink: referrerURL(),
    })
  }

  return (
    <li className='notification-preview-popup__item'>
      <a className='notification-preview-popup__link' href={referrerURL()} onClick={sendEvent}>
        <div className='notification-preview-popup__category-container'>
          {notification.category_icon_url && <img className='notification-preview-popup__category' src={notification.category_icon_url} alt="" />}
          {!notification.seen && <div className='notification-preview-popup__icon-unread' />}
        </div>
        <div className='notification-preview-popup__wrapper'>
          <p className={`notification-preview-popup__text-content ${notification.type === 'large' ? 'large' : ''} small-title-2`}>
            <b>{notification.title}</b>
          </p>
          <p className='notification-preview-popup__text-content small-title-2'>
            {notification.body}
          </p>
          {notification.type === 'large' && notification.image_url ?
            <img className='notification-preview-popup__image-large' src={notification.image_url} alt="" />
            : null}
          <time className='notification-preview-popup__item-time tiny-label'>
            {TimeagoAdapter.indonesian(notification.timestamp)}
          </time>
        </div>
        {notification.type === 'medium' && notification.image_url ?
          <img className='notification-preview-popup__image' src={notification.image_url} alt="" />
          : null}
      </a>
    </li>
  )
}

function NotificationPreviewPopupEmpty() {
  return (
    <div className='notification-preview-popup'>
      <div className='notification-preview-popup__header'>
        <h3 className='title-3'>Notifikasi</h3>
      </div>
      <Empty smallVersion />
    </div>
  )
}

export function NotificationPreviewPopupNonLogin() {
  useEffect(() => {
    AhoyEvent.send('VIDIO::NOTIFICATION', { action: 'impression', section: 'all' })
  }, [])

  return (
    <div className='notification-preview-popup'>
      <div className='notification-preview-popup__header'>
        <h3 className='title-3'>Notifikasi</h3>
      </div>
      <NonLogin />
    </div>
  )
}

export function NotificationPreviewPopup({ data }) {
  useEffect(() => {
    AhoyEvent.send('VIDIO::NOTIFICATION', { action: 'impression', section: 'all' })
  }, [])

  if (data.notifications.length === 0) {
    return <NotificationPreviewPopupEmpty />
  }

  const model = new NotificationDataModel(data)
  const notifications = model.notificationsData()
  const filteredNotifications = notifications.slice(0, 15)

  return (
    <div className='notification-preview-popup'>
      <div className='notification-preview-popup__header'>
        <h3 className='title-3'>Notifikasi</h3>
      </div>
      <ul className='notification-preview-popup__list'>
        {filteredNotifications.map(notification => (
          <NotificationPreviewItem
            key={`${notification.timestamp}`}
            notification={notification}
          />
        ))}
      </ul>
      <div className='notification-preview-popup__footer'>
        <a className='notification-preview-popup__footer-text small-title-1' href="/notifications">
          Lihat lebih banyak notifikasi
        </a>
      </div>
    </div>
  )
}

NotificationPreviewPopup.propTypes = {
  data: PropTypes.shape({
    notifications: PropTypes.arrayOf(PropTypes.object),
    categories: PropTypes.arrayOf(PropTypes.object)
  }).isRequired
}
